import { useAtomValue } from "jotai";
import { userProfileStateAtom } from "state/userProfileAtoms";
import { Booking, BookingStatus } from "src/common/event/event.types";
import { Slot } from "src/containers/event/event.types";
import { find, size } from "lodash-es";

export const useSlotBookedOrFull = (slot: Slot): { isBooked: boolean; isFull: boolean; userId: string } => {
  const userProfile = useAtomValue(userProfileStateAtom);
  const userId = userProfile.userInfo.userId || "";
  const isBooked = !!find(
    slot.bookings,
    (b: Booking) => b.inviteeContactId === userId && b.status === BookingStatus.Booked
  );
  const isFull = size(slot.bookings) >= slot.capacity;
  return { isBooked, isFull, userId };
};
